import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const Button = styled(({ color, ...rest }) => <Link {...rest} />)`
  display: inline-block;
  width: auto;
  padding: ${({small}) => small ? '4px 14px' : '14px'};
  border: 2px solid ${({ theme }) => theme.colorMain};
  border-radius: 3px;
  font-size: 36px;
  line-height: 1;
  color: inherit;
  background-color: transparent;

  @media only screen and (max-width: 810px) {
    padding: ${({small}) => small ? '2px 7px' : '7px'};
    border-width: 1px;
  }
`;

export default Button;
